/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 14:33:56
 * @LastEditors: linxi
 * @LastEditTime: 2024-09-23 16:53:12
 */
import { SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Space,
  Table,
} from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import {
  DateRangeType,
  DateSelect,
  getDateRange,
} from '../../compnents/form/DateSelect'
import { EditableList } from '../../compnents/list/EditableList'
import { ThemeContext } from '../../theme/ThemeContext'
import { getPatientLabels } from '../patient/list/patientListSlice'
import { AddMembersModal } from './addMembersModal'
import { TopUpModal } from './topUpModal'
import { TopUpRecordModal } from './topUpRecordModal'
import { Columns } from './columns'
import styles from './MembersManagementPage.module.css'
import { useHistory } from 'react-router-dom'
import {
  getAddMembers,
  getMembersPage,
  getMembersTopUp,
} from './MembersManagementPageSlice'
import { Query } from './Query'
import { BindMembersModal } from './bindMemberModal'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../models/dataPersion'
interface MembersManagementPageProps {
  state?: string
  isMenu?: boolean
  inTab?: boolean
}

export const MembersManagementPage = ({
  state,
  isMenu = false,
  inTab = false,
}: MembersManagementPageProps): ReactElement => {
  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [params, setParams] = useState({ current: 1, size: 10, startTime: '', endTime: '' })

  const [page, setPage] = useState({ items: [], total: 0, balanceMoneySUM: 0 })

  const [pageLoading, setPageLoading] = useState(false) // 表格 loading

  const [addMembersVisible, setAddMembersVisible] = useState(false) // 新增会员弹窗

  // 会员卡绑定弹窗
  const [bindMembersVisible, setBindMembersVisible] = useState(false) // 新增会员弹窗 

  const [addBtnType, setAddBtnType] = useState(false) // 新增会员弹窗

  const [topUpModalVisible, setTopUpModalVisible] = useState(false) // 充值 or 退款 弹窗

  const [membersId, setMembersId] = useState(0) // 会员 ID

  const [editId, setEditId] = useState<any>() //编辑id

  const [topUpRecordModalVisible, setTopUpRecordModalVisible] = useState(false) // 充值记录弹窗

  const [modalText, setModalText] = useState(0) // 充值 or 退款 弹窗标题
    
  const [QXData, setQXData] = useState(true)

  // 获取查看患者手机号数据权限
  const getCheckPermissionFn = () => {
    // isMenu为true时会员管理  否则是患者管理的会员
    const itemCode = isMenu ? SJQXChecks.HYGLCKHZSJH : SJQXChecks.HZGLCKHZSJH
    dispatch(getCheckPermissionAsync({ itemCode: itemCode }))
      .then(unwrapResult)
      .then((res: any) => {
        setQXData(res)
      })
  }

  useEffect(() => {
    getCheckPermissionFn()
  }, [])

  const [sortedInfo, setSortedInfo] = useState<any>({}) // 排序状态

  const getTablePage = () => {
    // 兼容 columnKey 和 field
    const sortField = sortedInfo?.columnKey || sortedInfo?.field
    const sortOrder = sortedInfo?.order
    
    // 根据排序方向确定排序值：升序=0，降序=1，取消排序=undefined
    const getSortValue = (field: string) => {
      if (sortField !== field) return undefined
      if (sortOrder === 'ascend') return 0
      if (sortOrder === 'descend') return 1
      return undefined // 取消排序
    }
    
    setPageLoading(true)
    dispatch(getMembersPage({
      ...params,
      startTime: params?.startTime ? params?.startTime : '',
      endTime: params?.endTime ? params?.endTime : '',
      // 添加排序参数
      memberNameSort: getSortValue('memberName'),
      cardNoSort: getSortValue('cardNo'),
      balanceMoneySort: getSortValue('balanceMoney'),
      createTimeSort: getSortValue('createTime'),
    }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          balanceMoneySUM: res?.balanceMoneySUM,
          items: res?.memberPageVO?.records,
          total: res?.memberPageVO?.total,
        })
      })
      .finally(() => setPageLoading(false))
  }


  useEffect(() => {
    !isMenu &&
      sessionStorage.setItem(location.pathname, JSON.stringify({ state }))
  }, [state])
  useEffect(() => {
    params.current && getTablePage()
  }, [params, sortedInfo])


  return (
    <Col className={state ? styles.wrap : styles.wraps} style={inTab ? { margin: '5px 0', height: 'calc(100% - 10px)', overflow: 'hidden' } : undefined}>
      <Query
        loading={pageLoading}
        onValueChange={(v) => {
          setParams({
            ...params,
            ...v,
            current: 1,
          })
        }}
        addMember={() => {
          setAddMembersVisible(true)
          setEditId('')
        }}
        // 会员卡管理
        manageMember={() => {
          history.push({
            pathname: '/member/membersCardManagement',
            state: {
              isMenu,
              QXData,
            },
          })
        }}
        // 会员卡绑定
        bindMember={() => {
          setBindMembersVisible(true)
        }}
      />
      <EditableList
        className={styles.patientLable}
        loading={pageLoading}
        page={{
          items: page.items,
          current: params.current,
          size: params.size,
          total: page.total,
        }}
        onChangePage={(current, size) =>
          setParams({ ...params, current, size: size || 10 })
        }
        columns={Columns((text, t) => {
          if (text === 'topUp') {
            setMembersId(t.id)
            setTopUpModalVisible(true)
            setModalText(0)
          } else if (text == 'refund') {
            setTopUpModalVisible(true)
            setModalText(1)
          } else if (text == 'topUpRecord') {
            setTopUpRecordModalVisible(true)
          } else if (text == 'edit') {
            setAddMembersVisible(true)
            setEditId(t?.id)
          } else if (text == 'detail') {
            history.push({
              pathname: '/member/membersManagement',
              state: {
                membersId: t.id,
                isMenu,
              },
            })
          }
          setMembersId(t.id)
        }, params.size * (params.current - 1), QXData, sortedInfo)}
        onChange={(pagination, filters, sorter: any) => {
          setSortedInfo(sorter)
        }}
        summary={() => (
          <Table.Summary fixed='bottom'>
            <Table.Summary.Row className={styles.total}>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1} align='center'>
                合计
              </Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3}></Table.Summary.Cell>
              <Table.Summary.Cell index={4}></Table.Summary.Cell>
              <Table.Summary.Cell index={5} align='center'>
                {page?.balanceMoneySUM?.toFixed(2)}
              </Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={7}></Table.Summary.Cell>
              <Table.Summary.Cell index={8}></Table.Summary.Cell>
            </Table.Summary.Row>
          </Table.Summary>
        )}
        onRow={(t) => ({
          onDoubleClick: () => {
            history.push({
              pathname: '/member/membersManagement',
              state: {
                membersId: t.id,
                isMenu,
              },
            })
          },
        })}
      />

      <AddMembersModal // 新增会员
        QXData={QXData}
        editId={editId}
        visible={addMembersVisible}
        btnType={addBtnType}
        onCancel={() => setAddMembersVisible(false)}
        onOk={(data) => {
          dispatch(getAddMembers(data))
            .then(unwrapResult)
            .then(() => {
              setAddMembersVisible(false)
              setParams({
                ...params,
              })
            })
            .finally(() => setAddBtnType(!addBtnType))
        }}
      />
      <TopUpModal //充值 or 退款
        QXData={QXData}
        visible={topUpModalVisible}
        btnType={addBtnType}
        membersId={membersId}
        modalText={modalText}
        onCancel={() => setTopUpModalVisible(false)}
        onOk={(data) => {
          dispatch(getMembersTopUp(data))
            .then(unwrapResult)
            .then(() => {
              setTopUpModalVisible(false)
              setParams({
                ...params,
              })
              notification.success({
                message: modalText ? '退款成功' : '充值成功',
              })
            })
            .finally(() => setAddBtnType(!addBtnType))
        }}
      />
      <TopUpRecordModal // 充值记录
        QXData={QXData}
        visible={topUpRecordModalVisible}
        membersId={membersId}
        onCancel={() => setTopUpRecordModalVisible(false)}
      />
      <BindMembersModal // 会员卡绑定
        QXData={QXData}
        visible={bindMembersVisible}
        onCancel={() => {
          setBindMembersVisible(false)
        }}
        onOk={() => {
          setBindMembersVisible(false)
          getTablePage()
        }}
      />
    </Col>
  )
}
